import {
    createContext,
    useContext,
    useEffect,
    useState,
} from "react";

import {
    doc,
    onSnapshot,
} from "firebase/firestore";

import { db } from "../firebase";
import { useAuth } from "./AuthContext";

const UserContext = createContext();

export function UserProvider({ children }) {

    const { user } = useAuth();

    const [profile, setProfile] = useState(null);

    useEffect(() => {

        if (!user) {

            setProfile(null);
            return;

        }

        const unsubscribe = onSnapshot(

            doc(
                db,
                "users",
                user.uid
            ),

            (snapshot) => {

                if (snapshot.exists()) {

                    setProfile(
                        snapshot.data()
                    );

                }

            }

        );

        return unsubscribe;

    }, [user]);

    return (

        <UserContext.Provider
            value={{ profile }}
        >

            {children}

        </UserContext.Provider>

    );

}

export function useUser() {

    return useContext(UserContext);

}